import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/my/rapport")({
  component: lazyImportRouteComponent(
    () => import("./duty-roster/-components/PrintMonthlyReportPage"),
    "PrintMonthlyReportPage"
  ),
  beforeLoad: (context) => {
    return {
      getTitle: () =>
        context.context.t && context.context.t("PersonalDutyRosterPrint"),
    }
  },
})
